import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'USA_SCREEN_APP_ALL',
        delete: 'USA_SCREEN_APP_DELETE'
      },
      permission: {
        query: '',
        add: 'new_screen_app',
        edit: 'update_screen_app',
        detail: '',
        remove: 'delete_screen_app'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '50px'
      }, {
        prop: 'soft_name',
        label: this.$t('soft_name'),
        minWidth: '100px'
      }, {
        prop: 'soft_url',
        label: this.$t('soft_url'),
        minWidth: '160px'
      }, {
        prop: 'soft_md5',
        label: this.$t('soft_md5'),
        minWidth: '120px'
      }, {
        prop: 'soft_version',
        label: this.$t('soft_version'),
        minWidth: '100px'
      }, {
        prop: 'status',
        label: this.$t('status'),
        minWidth: '80px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("div", [h("d2-dict", {
            "attrs": {
              "name": "screen_app_status",
              "value": row.status
            }
          }), "-", row.status]);
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref2) {
        var row = _ref2.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'soft_name',
        label: this.$t('soft_name'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:350px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.soft_name,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "soft_name", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/page', ['closeBy']))
};